import objectPath from 'object-path'

const getRuleClickButtonTarget = (action = {}, target = '') => {
  return (
    target ||
    action.target ||
    action.targetKey ||
    action.key ||
    action.valueKey ||
    action.targetName ||
    action.targetOptionValue ||
    action.formDataKey ||
    ''
  )
}

const getRuleClickButtonStatus = (status = {}) => {
  let { isDynamic, dynamicName, dynamicKey, dynamicIndex } = status

  return {
    isDynamic,
    dynamicName,
    dynamicKey,
    dynamicIndex,
  }
}

export const onRuleClickButton = (
  designContext = {},
  action = {},
  status = {},
  target = '',
) => {
  let { isUiChanged = {}, setIsUiChanged } = designContext
  let targetKey = getRuleClickButtonTarget(action, target)
  if (!targetKey) return undefined

  objectPath.set(isUiChanged, targetKey, {
    isClickButton: true,
    ...getRuleClickButtonStatus(status),
  })
  if (setIsUiChanged) setIsUiChanged(isUiChanged)

  return {
    key: targetKey,
    isClickButton: true,
  }
}
